import { useMutation, useQueryClient } from "@tanstack/react-query";

import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { useContractService } from "contexts/ServiceContext";
import { contractQueryKeyFactory } from "hooks/api/contracts/useContractDetails";
import { CONTRACTS_QUERY_KEY } from "hooks/api/contracts/useContracts";
import { RequestContractValues } from "services/ContractService";
import { BrokenRuleValidationError } from "services/apiErrors";

const useCreateRequestContract = () => {
  const selectedCustomerCode = useSelectedCustomerCode()[0];
  const contractService = useContractService();
  const queryClient = useQueryClient();
  return useMutation<
    number,
    BrokenRuleValidationError | Error,
    RequestContractValues
  >({
    mutationKey: [
      "create-request-contract",
      { cardCode: selectedCustomerCode },
    ],
    mutationFn: (values: RequestContractValues) =>
      selectedCustomerCode
        ? contractService.requestContract(selectedCustomerCode, values)
        : Promise.reject("Invalid or missing customer code"),
    onSuccess: () =>
      Promise.all([
        queryClient.refetchQueries(contractQueryKeyFactory()),
        queryClient.refetchQueries([CONTRACTS_QUERY_KEY]),
      ]),
  });
};

export default useCreateRequestContract;
